import { render, staticRenderFns } from "./ClientsTab.vue?vue&type=template&id=a2e1392a"
import script from "./ClientsTab.vue?vue&type=script&lang=js"
export * from "./ClientsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports